/* 🤖 this file was generated by svg-to-ts*/
export const qualitasIconBird: {
  name: 'bird';
  data: string;
} = {
  name: 'bird',
  data: `<svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M78.27 19.428c-1.163-2.75-13.165-7.19-17.13 10.523L40.2 45.655 8.879 64.409l1.57.543 4.16-1.214L8 67.64l2.167.75 22.42-6.662s10.114 1.382 17.995 1.387l-1.115 2.23c-.375.75 2.798 8.263 3.97 11.84l-5.929.901c-.706.108-.405 1.177.295 1.07l6.243-.947 6.243.948c.7.106 1.001-.963.295-1.07l-5.98-.91-.273-.922a6102.73 6102.73 0 00-1.061-3.595l-1.984-6.715c-.004-.016-.01-.026-.013-.04.24-.48 7.805-3.929 7.805-3.929h-.004c27.486-9.894 12.347-32.575 18.14-36.097C79.65 24.398 88 22.178 88 22.178c0-2.527-9.73-2.75-9.73-2.75z" fill="currentColor"/></svg>`
};
